import { render, staticRenderFns } from "./workflow-list.vue?vue&type=template&id=709ba5d4"
import script from "./workflow-list.vue?vue&type=script&lang=js"
export * from "./workflow-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports